import * as React from "react";
import type { SVGProps } from "react";
const SvgCancelled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#cancelled_svg__a)">
      <path d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10m0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8" />
      <path d="M18.3 19.3c-.26 0-.51-.1-.71-.29L4.99 6.41A.996.996 0 1 1 6.4 5L19 17.6a.996.996 0 0 1-.71 1.7z" />
    </g>
    <defs>
      <clipPath id="cancelled_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCancelled;
